import './Status.css'

const Status = ({status,style, label}) => {

    switch (status) {
        case "failed":
            return <Failed style={style} label={label} />
        case "expired":
            return <Expired style={style} label={label} />
        case "passed":
            return <Passed style={style} label={label} />
        case "pending":
            return <Pending style={style} label={label} />
        case "scheduled":
            return <Scheduled style={style} label={label} />
        case "default-status":
            return <DefaultStatus style={style} label={label} />
    }
}

export default Status

export const DefaultStatus = ({style={},label="DEFAULT"}) => {
    return (<div style={style} className={"default-status"}>
        <div className={"default-status-text"}>
            {label}
        </div>
    </div>)
}

export const Scheduled = ({style={},label="SCHEDULED"}) => {
    return (<div style={style} className={"status scheduled"}>
        {label}
    </div>)
}
export const Pending = ({style={},label="PENDING"}) => {
    return (<div style={style} className={"status pending"}>
        {label}
    </div>)
}
export const Passed = ({style={},label="PASSED"}) => {
    return (<div style={style} className={"status passed"}>
        {label}
    </div>)
}
export const Failed = ({style={},label="FAILED"}) => {
    return (<div style={style} className={"status failed"}>
        {label}
    </div>)
}

export const Expired = ({style={},label="EXPIRED"}) => {
    return (<div style={style} className={"status expired"}>
        {label}
    </div>)
}